import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export const PEOPLE_KEYWORD_SUGGESTION_SUB_ENTITY_TYPES: readonly string[] = [
    'PeopleKeywordAsText',
    'History',
    'EmailKPE',
];

type PeopleKeywordRankingFlight =
    // Requests People+Keyword suggestions at the top of the suggestion list.
    | 'PkRankingTop'
    // Lets the service rank People+Keyword suggestions dynamically among other suggestions.
    | 'PkRankingDynamic';

export interface PeopleKeywordSuggestionRequestOptions {
    isEnabled: boolean;
    rankingMode: 'control' | 'legacy' | 'top' | 'dynamic';
    rankingFlight?: PeopleKeywordRankingFlight;
    subEntityTypes?: readonly string[];
}

export default function getPeopleKeywordSuggestionRequestOptions(
    isScenarioEligible: boolean = true
): PeopleKeywordSuggestionRequestOptions {
    let rankingMode: PeopleKeywordSuggestionRequestOptions['rankingMode'] = 'control';
    let rankingFlight: PeopleKeywordSuggestionRequestOptions['rankingFlight'];

    if (isScenarioEligible) {
        const isTopEnabled = isGlobalFeatureEnabled('sea-peopleKeywordRankingTop');
        const isDynamicEnabled = isGlobalFeatureEnabled('sea-peopleKeywordRankingDynamic');

        // Conflicting new treatments must not fall back to the legacy experiment.
        if (isTopEnabled && isDynamicEnabled) {
            rankingMode = 'control';
        } else if (isTopEnabled) {
            rankingMode = 'top';
            rankingFlight = 'PkRankingTop';
        } else if (isDynamicEnabled) {
            rankingMode = 'dynamic';
            rankingFlight = 'PkRankingDynamic';
        } else if (isGlobalFeatureEnabled('sea-peopleKeywordAsTextSuggestion')) {
            rankingMode = 'legacy';
        }
    }

    const isEnabled = rankingMode !== 'control';

    return {
        isEnabled,
        rankingMode,
        rankingFlight,
        subEntityTypes: isEnabled ? PEOPLE_KEYWORD_SUGGESTION_SUB_ENTITY_TYPES : undefined,
    };
}
